export const EFFECT_LANDINGS = [
  {
    slug: 'bezsennosc', label: 'Bezsenność', effect: 'bezsenność', en: 'insomnia',
    terpenes: ['mircen', 'pinen', 'linalol'],
    introPl: 'W kontekście snu badane są terpeny: ',
    introEn: 'Terpenes studied in relation to sleep include: ',
    contextPl: 'Dane o działaniu nasennym tych związków pochodzą przede wszystkim z badań na zwierzętach. Wyniki badań olejku lawendowego lub mieszanek CBD z terpenami nie potwierdzają działania samego linalolu ani konkretnej odmiany.',
    contextEn: 'Evidence for sleep-related effects of these compounds comes primarily from animal studies. Findings on lavender oil or CBD–terpene mixtures do not establish the effects of isolated linalool or any specific strain.',
  },
  {
    slug: 'bol', label: 'Ból', effect: 'ból', en: 'pain',
    terpenes: ['mircen', 'humulen', 'pinen', 'linalol', 'ocymen', 'bisabolol'],
    introPl: 'W badaniach nad odczuwaniem bólu analizowane są terpeny: ',
    introEn: 'Terpenes investigated in pain research include: ',
    contextPl: 'Opisane w encyklopedii działania przeciwbólowe opierają się głównie na modelach zwierzęcych; wyniki zależą od rodzaju bólu i sposobu podania. Nie można ich bezpośrednio przenieść na skuteczność suszu u Pacjentów.',
    contextEn: 'The analgesic effects described in the encyclopedia rely mainly on animal models; findings depend on pain type and administration route. They cannot directly establish the effectiveness of cannabis flower in patients.',
  },
  {
    slug: 'lek', label: 'Lęk', effect: 'lęk', en: 'anxiety',
    terpenes: ['mircen', 'nerolidol', 'eukaliptol', 'limonen', 'pinen', 'bisabolol', 'linalol'],
    introPl: 'Do przeglądu profili w kontekście lęku wybrano terpeny: ',
    introEn: 'Terpenes selected for reviewing profiles in the context of anxiety are: ',
    contextPl: 'Większość danych dotyczy badań przedklinicznych. Limonen badano również u zdrowych dorosłych w kontekście niepokoju wywołanego THC — nie jest to dowód leczenia zaburzeń lękowych. THC może nasilać lęk, a dobór terapii wymaga konsultacji z lekarzem.',
    contextEn: 'Most evidence is preclinical. Limonene has also been studied in healthy adults for THC-induced anxiety — this is not evidence of treatment for anxiety disorders. THC can worsen anxiety, and treatment selection requires medical consultation.',
  },
];

export function getEffectLanding(slug) {
  return EFFECT_LANDINGS.find(topic => topic.slug === slug);
}

export function getEffectLandingMeta(topic, language) {
  const pl = language !== 'en';
  return {
    title: pl ? `Odmiany na ${topic.effect} - terpeny i opinie pacjentów | TerpeneAtlas` : `Strains for ${topic.en} - terpenes and patient reviews | TerpeneAtlas`,
    description: pl ? `Odmiany medycznej marihuany na ${topic.effect}: przegląd profili zawierających wybrane terpeny, źródła naukowe i opinie pacjentów. Materiał edukacyjny TerpeneAtlas.` : `Medical cannabis strains for ${topic.en}: profiles containing selected terpenes, scientific evidence and patient reviews. Educational material from TerpeneAtlas.`,
  };
}